module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "12"
    }
  }, [_c('b-card', {
    staticClass: "formCardDash"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Assignments")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Total Assignments: " + _vm._s(_vm.totalRecords))])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Search by job no, client name...",
      "size": "sm"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [10, 25, 50, 100],
      "size": "sm"
    },
    on: {
      "change": _vm.updatePagination
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-info",
      "size": "sm",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.refreshData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.isLoading
    }
  }), _vm._v("\n            Refresh\n          ")])], 1)], 1), _vm._v(" "), _c('b-table', {
    staticClass: "mb-0",
    attrs: {
      "items": _vm.assignmentsData,
      "fields": _vm.fields,
      "busy": _vm.isLoading,
      "striped": "",
      "bordered": "",
      "hover": "",
      "small": "",
      "show-empty": "",
      "empty-text": "No assignment data found"
    },
    scopedSlots: _vm._u([{
      key: "JobNo",
      fn: function(data) {
        return [_c('code', [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "JobDate",
      fn: function(data) {
        return [_vm._v("\n          " + _vm._s(_vm.formatDate(data.value)) + "\n        ")]
      }
    }, {
      key: "JobType",
      fn: function(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.getJobTypeVariant(data.value)
          }
        }, [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "status",
      fn: function(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.getStatusVariant(data.value)
          }
        }, [_vm._v(_vm._s(_vm.getStatusText(data.value)))])]
      }
    }, {
      key: "ClientName",
      fn: function(data) {
        return [_c('strong', [_vm._v(_vm._s(data.value || 'Unknown'))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(data.item.EnqNo || '-'))])]
      }
    }, {
      key: "POL",
      fn: function(data) {
        return [_c('small', [_vm._v(_vm._s(data.value) + " → " + _vm._s(data.item.POD))])]
      }
    }, {
      key: "assignmentType",
      fn: function(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.getAssignmentTypeVariant(data.value)
          }
        }, [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "actions",
      fn: function(data) {
        return [_c('b-button', {
          staticClass: "toggle-btn",
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.toggleDetails(data.item)
            }
          }
        }, [_c('i', {
          class: data.item._showDetails ? 'fa fa-chevron-up' : 'fa fa-chevron-down'
        })])]
      }
    }, {
      key: "row-details",
      fn: function(row) {
        return [_c('div', {
          staticClass: "row-details"
        }, [_c('div', {
          staticClass: "row mb-3"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "card border-primary"
        }, [_c('div', {
          staticClass: "card-header bg-primary text-white"
        }, [_c('i', {
          staticClass: "fa fa-briefcase"
        }), _vm._v(" Job Details\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "card-body"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Job No:")]), _vm._v(" " + _vm._s(row.item.JobNo) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Job Date:")]), _vm._v(" " + _vm._s(_vm.formatDate(row.item.JobDate)) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Job Type:")]), _vm._v(" " + _vm._s(row.item.JobType) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Transport Type:")]), _vm._v(" " + _vm._s(row.item.JobTransportType) + "\n                      ")])]), _vm._v(" "), _c('div', {
          staticClass: "row mt-2"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Container Type:")]), _vm._v(" " + _vm._s(row.item.JobTContainerType || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Shipment Type:")]), _vm._v(" " + _vm._s(row.item.JobShipmentType || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Raised By:")]), _vm._v(" " + _vm._s(row.item.RaisedBy) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Raised From:")]), _vm._v(" " + _vm._s(row.item.RaisedFrom) + "\n                      ")])]), _vm._v(" "), _c('div', {
          staticClass: "row mt-2"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Stuffing Type:")]), _vm._v(" " + _vm._s(row.item.stuffingType || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Multi Container No:")]), _vm._v(" " + _vm._s(row.item.multiConNo || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Branch ID:")]), _vm._v(" " + _vm._s(row.item.BranchID) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Status:")]), _vm._v(" " + _vm._s(_vm.getStatusText(row.item.status)) + "\n                      ")])])])])])]), _vm._v(" "), _c('div', {
          staticClass: "row mb-3"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "card border-success"
        }, [_c('div', {
          staticClass: "card-header bg-success text-white"
        }, [_c('i', {
          staticClass: "fa fa-map-marker"
        }), _vm._v(" Location Details\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "card-body"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("POR:")]), _vm._v(" " + _vm._s(row.item.POR || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("POL:")]), _vm._v(" " + _vm._s(row.item.POL || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("POD:")]), _vm._v(" " + _vm._s(row.item.POD || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("FPOD:")]), _vm._v(" " + _vm._s(row.item.FPOD || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("Stuffing:")]), _vm._v(" " + _vm._s(row.item.STUFF || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("Handover:")]), _vm._v(" " + _vm._s(row.item.HAND || '-') + "\n                      ")])]), _vm._v(" "), _c('div', {
          staticClass: "row mt-2"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Pick:")]), _vm._v(" " + _vm._s(row.item.PICK || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("SOB Date:")]), _vm._v(" " + _vm._s(_vm.formatDate(row.item.sob_date_detected)) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("ETA Est.:")]), _vm._v(" " + _vm._s(_vm.formatDate(row.item.ETA_destination_estimated)) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("ETA Act.:")]), _vm._v(" " + _vm._s(_vm.formatDate(row.item.ETA_destination_actual)) + "\n                      ")])])])])])]), _vm._v(" "), _c('div', {
          staticClass: "row mb-3"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "card border-warning"
        }, [_c('div', {
          staticClass: "card-header bg-warning"
        }, [_c('i', {
          staticClass: "fa fa-users"
        }), _vm._v(" Client & Enquiry Details\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "card-body"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Main Client:")]), _vm._v(" " + _vm._s(row.item.ClientName || 'Unknown') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Exporter:")]), _vm._v(" " + _vm._s(row.item.ExpClientName || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Importer:")]), _vm._v(" " + _vm._s(row.item.ImpClientName || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Enquiry:")]), _vm._v(" " + _vm._s(row.item.EnqNo || '-') + "\n                      ")])]), _vm._v(" "), _c('div', {
          staticClass: "row mt-2"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Enquiry Date:")]), _vm._v(" " + _vm._s(_vm.formatDate(row.item.EnqDate)) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Shipping Line:")]), _vm._v(" " + _vm._s(row.item.SlineName || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Login User:")]), _vm._v(" " + _vm._s(row.item.LoginUserName) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-6"
        }, [_c('strong', [_vm._v("Email:")]), _vm._v(" " + _vm._s(row.item.LoginUserEmail) + "\n                      ")])])])])])]), _vm._v(" "), _c('div', {
          staticClass: "row mb-3"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "card border-info"
        }, [_c('div', {
          staticClass: "card-header bg-info text-white"
        }, [_c('i', {
          staticClass: "fa fa-ship"
        }), _vm._v(" Shipping & Billing Details\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "card-body"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("MBL:")]), _vm._v(" " + _vm._s(row.item.MBL || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("HBL:")]), _vm._v(" " + _vm._s(row.item.HBL || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("BL Type:")]), _vm._v(" " + _vm._s(row.item.BlType || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Vessel/Voyage:")]), _vm._v(" " + _vm._s(row.item.VesselVoyage || '-') + "\n                      ")])]), _vm._v(" "), _c('div', {
          staticClass: "row mt-2"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Freight Terms MBL:")]), _vm._v(" " + _vm._s(row.item.FreightTermsMbl || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Freight Terms HBL:")]), _vm._v(" " + _vm._s(row.item.FreightTermsHbl || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Freight Terms Liner:")]), _vm._v(" " + _vm._s(row.item.FreightTermsLiner || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("MBL Release Date:")]), _vm._v(" " + _vm._s(_vm.formatDate(row.item.MBLReleaseDate)) + "\n                      ")])]), _vm._v(" "), _c('div', {
          staticClass: "row mt-2"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("MBL Date:")]), _vm._v(" " + _vm._s(_vm.formatDate(row.item.MBLDate)) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Particular Type:")]), _vm._v(" " + _vm._s(row.item.ParticularType || '-') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Buying Rate:")]), _vm._v(" " + _vm._s(_vm.formatCurrency(row.item.BuyingRate)) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Selling Rate:")]), _vm._v(" " + _vm._s(_vm.formatCurrency(row.item.SellingRate)) + "\n                      ")])])])])])]), _vm._v(" "), _c('div', {
          staticClass: "row mb-3"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "card border-secondary"
        }, [_c('div', {
          staticClass: "card-header bg-secondary text-white"
        }, [_c('i', {
          staticClass: "fa fa-check-circle"
        }), _vm._v(" Validation & Status Details\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "card-body"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("Expense Validation:")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row.item.is_expense_validation ? 'success' : 'danger'
          }
        }, [_vm._v("\n                          " + _vm._s(row.item.is_expense_validation ? 'Yes' : 'No') + "\n                        ")])], 1), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("Additional Task:")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row.item.is_additional_task_validation ? 'success' : 'danger'
          }
        }, [_vm._v("\n                          " + _vm._s(row.item.is_additional_task_validation ? 'Yes' : 'No') + "\n                        ")])], 1), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("SLine Validation:")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row.item.is_sline_validation ? 'success' : 'danger'
          }
        }, [_vm._v("\n                          " + _vm._s(row.item.is_sline_validation ? 'Yes' : 'No') + "\n                        ")])], 1), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("NOE Validation:")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row.item.is_noe_validation ? 'success' : 'danger'
          }
        }, [_vm._v("\n                          " + _vm._s(row.item.is_noe_validation ? 'Yes' : 'No') + "\n                        ")])], 1), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("All Active:")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row.item.isAllActive ? 'success' : 'danger'
          }
        }, [_vm._v("\n                          " + _vm._s(row.item.isAllActive ? 'Yes' : 'No') + "\n                        ")])], 1), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("Consolidation:")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row.item.isConsolidation ? 'success' : 'danger'
          }
        }, [_vm._v("\n                          " + _vm._s(row.item.isConsolidation ? 'Yes' : 'No') + "\n                        ")])], 1)]), _vm._v(" "), _c('div', {
          staticClass: "row mt-2"
        }, [_c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("Final Sales Billing:")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row.item.isfinalsalesBillingComplete ? 'success' : 'danger'
          }
        }, [_vm._v("\n                          " + _vm._s(row.item.isfinalsalesBillingComplete ? 'Complete' : 'Pending') + "\n                        ")])], 1), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("TPT Invoice:")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row.item.tptInvoiceClosed ? 'success' : 'danger'
          }
        }, [_vm._v("\n                          " + _vm._s(row.item.tptInvoiceClosed ? 'Closed' : 'Open') + "\n                        ")])], 1), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("CC Invoice:")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row.item.ccInvoiceClosed ? 'success' : 'danger'
          }
        }, [_vm._v("\n                          " + _vm._s(row.item.ccInvoiceClosed ? 'Closed' : 'Open') + "\n                        ")])], 1), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("FF Invoice:")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row.item.ffInvoiceClosed ? 'success' : 'danger'
          }
        }, [_vm._v("\n                          " + _vm._s(row.item.ffInvoiceClosed ? 'Closed' : 'Open') + "\n                        ")])], 1), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("FF Locked:")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row.item.ff_is_locked ? 'warning' : 'success'
          }
        }, [_vm._v("\n                          " + _vm._s(row.item.ff_is_locked ? 'Locked' : 'Unlocked') + "\n                        ")])], 1), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("TPT Locked:")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row.item.tpt_is_locked ? 'warning' : 'success'
          }
        }, [_vm._v("\n                          " + _vm._s(row.item.tpt_is_locked ? 'Locked' : 'Unlocked') + "\n                        ")])], 1)])])])])]), _vm._v(" "), (row.item.subscriptionTracking && row.item.subscriptionTracking.length > 0) ? _c('div', {
          staticClass: "row mb-3"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "card border-danger"
        }, [_c('div', {
          staticClass: "card-header bg-danger text-white"
        }, [_c('i', {
          staticClass: "fa fa-rss"
        }), _vm._v(" Subscription Tracking (" + _vm._s(row.item.subscriptionTracking.length) + ")\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "card-body p-0"
        }, [_c('b-table', {
          staticClass: "mb-0",
          attrs: {
            "items": row.item.subscriptionTracking,
            "fields": _vm.subscriptionFields,
            "small": "",
            "bordered": ""
          },
          scopedSlots: _vm._u([{
            key: "subscription_status_detials_status",
            fn: function(data) {
              return [_c('b-badge', {
                attrs: {
                  "variant": data.value === 1 ? 'success' : 'warning'
                }
              }, [_vm._v("\n                          " + _vm._s(data.value === 1 ? 'Active' : 'Inactive') + "\n                        ")])]
            }
          }])
        })], 1)])])]) : _vm._e()])]
      }
    }])
  }, [_c('template', {
    slot: "table-busy"
  }, [_c('div', {
    staticClass: "text-center text-danger my-2"
  }, [_c('b-spinner', {
    staticClass: "align-middle",
    attrs: {
      "small": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "ml-2"
  }, [_vm._v("Loading...")])], 1)])], 2), _vm._v(" "), (_vm.totalItems > _vm.pagination.perPage) ? _c('b-pagination', {
    staticClass: "mt-3",
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalItems
    },
    on: {
      "change": _vm.onPageChange
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-2 d-flex justify-content-between align-items-center"
  }, [_c('div', [_c('b-form-select', {
    staticClass: "w-auto",
    attrs: {
      "options": _vm.pagination.pageOptions,
      "size": "sm"
    },
    on: {
      "change": _vm.updatePagination
    },
    model: {
      value: (_vm.pagination.perPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "perPage", $$v)
      },
      expression: "pagination.perPage"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-muted"
  }, [_vm._v("per page")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-muted small"
  }, [_vm._v("\n          Total Records: " + _vm._s(_vm.totalItems) + "\n        ")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e9f569e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/salesPersonDashboard/AssignmentSection.vue
// module id = 2391
// module chunks = 0